<template>
  <div>
    <div style="font-size:1.4rem; padding:4px;margin-bottom:1.5rem">
      <strong>런치팩 공지사항</strong>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="title" slot-scope="props">
        <span style="border-bottom:1px solid; cursor: pointer" @click.stop.prevent="clickItem(props.item,'update')">{{ props.item.title }}</span>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button" @click.stop.prevent="clickItem(props.item,'update')">상세</button>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'BasicNoticeList',
    mixins: [
      ListMixin
    ],

    data() {
      return {
        modalItem: 0
      }
    },

    created () {
      this.init();
    },

    methods: {
      init () {
        this.initializing('launchpack_notice', 'launchpack/notice');
      },
      getDataFromServer() {
        this.getData();
      },
      clickItem(item, kind) {
        if (kind === "update") {
          this.$router.push(this.getPath("launchpack/notice/create?id=" + item.id));
        }
      },
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>

</style>
